export const LOCATIONS_QUERY = `
  query LocationQuery($search: String!) {
    locations(search: $search) {
      country
      key
      name
	  AdministrativeArea
    }
  }
`;
